// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router/index'
import 'normalize.css'
import './common/reset.scss'
import app from './app.vue'

window.__forceSmoothScrollPolyfill__ = true
require('smoothscroll-polyfill').polyfill()
require('window.requestanimationframe')

// FYI: https://www.npmjs.com/package/smoothscroll-polyfill
//require('smoothscroll-polyfill').polyfill()
//require('window.requestanimationframe')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<app/>',
  components: { app },
})



// WEBPACK FOOTER //
// ./src/apps/zcx/index.js